// Context + hook los van de provider-component (zelfde patroon als
// contexts/auth-context.js), zodat React Fast Refresh blijft werken.
import { createContext, useContext } from 'react';

export const ToastContext = createContext(() => {});

export function useToast() {
  return useContext(ToastContext);
}
